import styled from 'styled-components'
import { blue as blueColor, mildGray } from '../../styles/variables.js'

const IconButton = styled.div`
  display: inline-block;
  margin: 0 4px;

  cursor: pointer;
  color: ${mildGray};
  transition: all .1s ease-in-out;
  flex: 0 0;
  max-height: 24px;
  font-size: 22px;
  padding: 7px;
  margin: 0px 4px 4px 4px;

  &:hover {
    transform: scale(1.1);
    color: ${({ red }) => red ? 'red' : `${blueColor}`};
  }

`

export default {
  IconButton,
}
